import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';

import { getMinStdAnnexTemplateOptions, getMinStdOptions } from '@/module/MinimalStandard/model/MinStdQuery';

import { NoContentPlaceholder } from '@/core/components';

export const Route = createFileRoute('/_auth/minimal-standards/_layout/report/gather/_gather/')({
  component: RouteComponent,
});

function RouteComponent() {
  const { userId } = Route.useSearch();
  const { data: report } = useSuspenseQuery(getMinStdOptions(Number(userId)));
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const { data: template } = useSuspenseQuery(getMinStdAnnexTemplateOptions(report!.minStdAnnexNo!));
  const navigate = Route.useNavigate();

  useEffect(() => {
    if (template.indicators.length > 0) {
      navigate({
        to: `/minimal-standards/report/gather/$indicatorCode`,
        params: { indicatorCode: template.indicators[0].indicatorCode },
        search: true,
      });
    }
  }, [template, navigate]);

  return <NoContentPlaceholder title="Fara continut" />;
}
